const LANGUAGE_MAP: Record<string, string> = {
  english: "en",
  spanish: "es",
  french: "fr",
  german: "de",
  chinese: "zh",
  russian: "ru",
  italian: "it",
  japanese: "ja",
  korean: "ko",
  portuguese: "pt",
  "portuguese (brazil)": "pt-BR",
  dutch: "nl",
  arabic: "ar",
  hindi: "hi",
  turkish: "tr",
  vietnamese: "vi",
  polish: "pl",
  ukrainian: "uk",
  thai: "th",
  swedish: "sv",
  danish: "da",
  finnish: "fi",
  norwegian: "no",
  hebrew: "he",
  czech: "cs",
  greek: "el",
  hungarian: "hu",
  estonian: "et",
};

export const getLanguageCode = (string?: string): string | undefined => {
  if (!string) {
    return undefined;
  }
  const normalizedString = string.toLowerCase();
  return Object.entries(LANGUAGE_MAP).find(([key]) =>
    normalizedString.includes(key),
  )?.[1];
};
